var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.93,
    y1: 1.031,
    x2: -0.11,
    y2: -0.082,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e1b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#226fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.815,
    y1: 0.124,
    x2: 0.008,
    y2: 0.941,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc5d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#37b7c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00a9bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#007382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005d6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.208,
    y1: 0.801,
    x2: 0.775,
    y2: 0.143,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.31,
    y1: 0.025,
    x2: 1.143,
    y2: 0.976,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.339,
    y1: 0.891,
    x2: 0.99,
    y2: -0.163,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.675,
    y1: 0.042,
    x2: 0.433,
    y2: 0.839,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_55685",
    "data-name": "\\u7EC4 55685",
    transform: "translate(-505 -1878.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2297",
    "data-name": "\\u77E9\\u5F62 2297",
    width: 40,
    height: 40,
    transform: "translate(505 1878.85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_55683",
    "data-name": "\\u7EC4 55683",
    transform: "translate(505.664 1879.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_55681",
    "data-name": "\\u7EC4 55681",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8614",
    "data-name": "\\u8DEF\\u5F84 8614",
    d: "M469.67,409.079a16.692,16.692,0,0,1,7.153-13.709c-8.276,2.658-12.4,7.973-14.433,12.953a19.553,19.553,0,0,0,28.676,16.79,16.687,16.687,0,0,1-21.4-16.034Z",
    transform: "translate(-462.383 -388.248)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8615",
    "data-name": "\\u8DEF\\u5F84 8615",
    d: "M476.639,201.832a16.68,16.68,0,0,1,22,2.573,19.55,19.55,0,0,0-36.435,9.868q0,.256.007.511C464.243,209.8,468.364,204.49,476.639,201.832Z",
    transform: "translate(-462.2 -194.71)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8616",
    "data-name": "\\u8DEF\\u5F84 8616",
    d: "M476.639,201.832a16.68,16.68,0,0,1,22,2.573,19.55,19.55,0,0,0-36.435,9.868q0,.256.007.511C464.243,209.8,468.364,204.49,476.639,201.832Z",
    transform: "translate(-462.2 -194.71)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8617",
    "data-name": "\\u8DEF\\u5F84 8617",
    d: "M991.036,359.814a15.364,15.364,0,0,0-18.417-21.547A13.465,13.465,0,0,1,987,347.2C989.087,349.276,991.173,353.047,991.036,359.814Z",
    transform: "translate(-954.502 -332.461)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8618",
    "data-name": "\\u8DEF\\u5F84 8618",
    d: "M741.345,628.089a13.5,13.5,0,0,1-10.175-4.625,15.355,15.355,0,0,0,26.987-.812c.137-6.766-1.949-10.538-4.036-12.612a13.551,13.551,0,0,1-12.776,18.049Z",
    transform: "translate(-721.623 -595.299)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8619",
    "data-name": "\\u8DEF\\u5F84 8619",
    d: "M741.345,628.089a13.5,13.5,0,0,1-10.175-4.625,15.355,15.355,0,0,0,26.987-.812c.137-6.766-1.949-10.538-4.036-12.612a13.551,13.551,0,0,1-12.776,18.049Z",
    transform: "translate(-721.623 -595.299)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706_124",
    "data-name": "\\u692D\\u5706 124",
    cx: 7.306,
    cy: 7.638,
    rx: 7.306,
    ry: 7.638,
    transform: "translate(12.758 11.955)",
    fill: "url(#linear-gradient-7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e44ff62f2629c337616d2c55e88d69d.svg";
export { ForwardRef as ReactComponent };